import { FiArrowUpRight } from "react-icons/fi";
import "./ArrowStyle.css";
export default function Arrow({ site, projColor, cls }) {
  return (
    <div className={`github-icon ${cls}`}>
      <a href={site} target='_blank' rel='noreferrer' className='all-icons '>
        <FiArrowUpRight size={25} color={`var(--project-${projColor})`} className='icon' />
      </a>
    </div>
  );
}
